<div class="image-container">
  <img
    src="/assets/images/construction-site/construction.png"
    alt=""
    class="w-50 pt-5"
  />
</div>
